import { isValidDistinctTypeLimit } from '@/utils/slideLimitRuleset'

export const DISTINCT_TYPE_LIMIT_FLAG = 'BOO-1254-free-distinct-slide-type-limit'

export const DISTINCT_TYPE_LIMIT_VARIANTS = {
  TREATMENT: 'treatment',
}

export const DEFAULT_DISTINCT_TYPE_LIMIT_EXCLUDE = Object.freeze({
  type: [
    'textSlide', 'bulletPoints', 'image', 'youtube', 'googleSlides', 'document', 'embed',
    'qrCode', 'qrcode', 'leaderboard', 'freestyle', 'content-v2', 'html',
  ],
})

/**
 * Validates a distinct type limit and fills in the default exclude list.
 * @param {*} value candidate `{ id, limit, label?, exclude? }`
 * @returns {Object|null} the usable limit, or null when it is missing or malformed
 */
export const normalizeDistinctTypeLimit = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  const withExclude = value.exclude === undefined
    ? { ...value, exclude: DEFAULT_DISTINCT_TYPE_LIMIT_EXCLUDE }
    : value
  return isValidDistinctTypeLimit(withExclude) && withExclude.limit !== undefined ? withExclude : null
}

export const parseDistinctTypeLimitVariant = (variant) => {
  if (!variant || variant.name !== DISTINCT_TYPE_LIMIT_VARIANTS.TREATMENT) return null
  const raw = variant.payload && variant.payload.value
  let parsed = raw
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw)
    } catch (error) {
      return null
    }
  }
  return normalizeDistinctTypeLimit(parsed)
}
